export default {
    //baseURL: 'http://localhost:5000'
    baseURL: 'https://registryhub.wsp.com'
}